import {provideApolloClient} from '@vue/apollo-composable';
import {logErrorMessages} from '@vue/apollo-util';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useSofieConfig();

  provideApolloClient(useApollo().clients.default);

  nuxtApp.hook('apollo:headers', (headers) => {
    const requestHeaders = useRequestHeaders();
    const event = useRequestEvent();
    const req = event?.node?.req;
    const url = useRequestURL();

    if (config.apiToken) {
      headers.value['Sofie-Api-Token'] = config.apiToken;
    }

    headers.value['x-referer'] = url.href;

    if (req) {
      headers.value['x-forwarded-for'] = requestHeaders['cf-connecting-ip'] ||
          requestHeaders['x-forwarded-for'] ||
          req?.connection.remoteAddress ||
          req?.socket.remoteAddress;
    }
  });

  const errorCategoriesHandledByApp = [
    ...config.errorHandling.apolloCategoriesHandled ?? [],
    'authorization',
    'validation',
  ];

  nuxtApp.hook('apollo:error', (error) => {
    if (process.env.NODE_ENV === 'development') {
      logErrorMessages(error);
    }

    if (error.networkError?.statusCode === 503) {
      throw createError({
        statusCode: 503,
        statusMessage: 'sofie.maintenance.title',
      });
    }

    error.graphQLErrors?.forEach((graphqlError) => {
      if (!errorCategoriesHandledByApp.includes(graphqlError.extensions?.category as string)) {
        throw createError({statusCode: 500, statusMessage: graphqlError.message});
      }
    });
  });
});
